import React from 'react';
import * as Styled from './Standalone.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `Standalone` container is a "row" in the overall page layout and is a direct child of a Canvas block.
 * Standalone blocks can NOT live within `Layout` or `Section` blocks.
 *
 * In Whammy, a user will never drop a Standalone container block on the canvas. Any “standalone” content block MUST wrap themselves in a Standalone container.
 */
export const Standalone = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Styled.StandaloneContainer, {
    ...rest,
    children: children
  });
};